import {
  Action,
  combineReducers,
  ThunkAction,
  ThunkDispatch
} from '@reduxjs/toolkit';
import formFieldsReducer from './form-fields/form-fields.reducer';

const rootReducer = combineReducers({
  formFieldState: formFieldsReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppThunkDispatch<S = RootState, E = null> = ThunkDispatch<
  S,
  E,
  Action<string>
>;
export type AppThunkAction<S = RootState, E = null> = ThunkAction<
  Promise<void>, // Return
  S, // State
  E, // ExtraArgument
  Action<string> // ActionType
>;

export default rootReducer;
